<template>
  <ubi-page-container class="PortalsList" wide-main-content>
    <template v-if="results.count > 0" v-slot:page-actions>
      <router-link :to="{ name: 'portals-posts' }" class="inline" v-if="!user.roles.includes('ROLE_SUB_USER')">
        <el-button  type="warning">
                    <span @click="eventAnalytics('diffuser_annonces')">
                       {{ $t("portals.list.diffuseMyAds") }}
                    </span>
        </el-button>
      </router-link>

      <el-button
          type="primary"
          class="inline"
          @click="resetFiltersAndFetch"
          v-if="hasDiffusions && !showAllPortalsView"
      >
      <span @click="eventAnalytics('catalogue_portails')">
        {{ $t("portals.list.showAllPortals") }}
      </span>
      </el-button>

      <el-button
          type="primary"
          class="inline"
          @click="showActiveDiffusions"
          v-if="hasDiffusions && showAllPortalsView"
      >
      <span @click="eventAnalytics('retour_diffusions')">
        {{ $t("portals.list.returnToDiffusions") }}
      </span>
      </el-button>
    </template>
    <div
        v-loading="loading"
        :element-loading-text="$t('portals.list.chargementDonnees')"
        class="PortalsList-body"
        :class="{ 'PortalsList-body--initialLoad': isInitialLoading }"
    >

      <ApiSearchForm
          :template-code="templateCode"
          :business-domain="businessDomain"
          :route="route"
          @search="handleSearchFromApi"
          @reset="handleResetFromApi"
          v-if="hasDiffusions || hasDiffusion || allPortals.count > 0"
      />

      <el-form label-position="top" @submit.prevent.native="fetchList" v-if="hasDiffusions || hasDiffusion || allPortals.count > 0">
        <el-dialog class="modificationQuotaModal" :visible.sync="modificationQuotaModal">
            <span slot="title" v-if="currentPortalQuota">{{
                $t("portals.list.dialogEditPostQuota")
              }} {{ currentPortalQuota.nom }}</span>
          <span v-if="currentPortalQuota && (getFromSnake(currentPortalQuota, 'modification_par_annonceur_autorisee') === true)">
                <el-form>
                  <el-radio-group v-model="choixModalQuota">
                  <el-row>
                    <el-col :md="24">
                      <el-radio label="turnoff">{{ $t("portals.list.doNotBroadcast") }}</el-radio>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :md="24">
                      <el-radio label="unlimited">{{ $t("portals.list.unlimited") }}</el-radio>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :md="14">
                      <el-radio label="limit">{{ $t("portals.list.limitedToXPosts") }} : </el-radio>
                    </el-col>
                    <el-col :md="4">
                      <el-input size="mini" max="4" v-if="currentPortalQuota && currentPortalQuota.diffusion"
                                v-model="limitQuota">{{ limitQuota }}</el-input>
                    </el-col>
                  </el-row>
                </el-radio-group>
                </el-form>
              </span>
          <span v-else>
                {{ $t("portals.list.contactBroadcasterToEditQuota") }}
              </span>
          <span slot="footer" class="dialog-footer">
                <el-button @click="modificationQuotaModal = false">
                      <span @click="eventAnalytics('modale_modification_quota_fermer')">{{
                          $t("portals.list.close")
                        }}</span>
                   </el-button>
                <el-button type="primary" @click="modifierQuota">
                      <span>{{ $t("portals.list.confirm") }}</span>
                   </el-button>
              </span>
        </el-dialog>
        <el-dialog :visible.sync="modificationIdentifiantsModal">
          <span slot="title" v-if="currentPortal">{{ $t("portals.list.dialogEditIdentifiants") }} <span style="font-weight: bold;">{{ currentPortal.nom }}</span></span>
          <span v-if="identifiantsEditableAnnonceur">
                <el-form v-if="currentPortal && currentPortal.diffusion.identifiants">
                  <div v-for="identifiant in currentPortal.diffusion.identifiants" :key="identifiant.numero">
                    <el-row v-if="getFromSnake(identifiant, 'editable_annonceur')">
                      <el-col :md="6">{{ identifiant.libelle }}</el-col>
                      <el-col :md="6"><el-input type="text" size="mini" v-model="identifiant.valeur">{{ identifiant.valeur }}</el-input></el-col>
                    </el-row>
                    <br />
                  </div>
                </el-form>
                <span slot="footer" class="dialog-footer">
                    <el-button @click="modificationIdentifiantsModal = false">{{ $t("portals.list.close") }}</el-button>
                    <el-button type="primary" @click="modifierIdentifiants">{{ $t("portals.list.confirm") }}</el-button>
                </span>
              </span>
          <span v-else>
                <div>{{ $t("portals.list.aucunIdentifiantEditable") }}</div>
                <br />
                <span slot="footer" class="dialog-footer">
                    <el-button @click="modificationIdentifiantsModal = false">{{ $t("portals.list.close") }}</el-button>
                </span>
              </span>
        </el-dialog>
        <el-dialog class="SelectPortailPayantModal" :visible.sync="selectPortailPayant">
          <span slot="title" v-html="$t('portals.list.activationToPaidPortalTitle', {portal: nomPortail})"/>
          <span v-html="$t('portals.list.activationToPaidPortalText', {email: emailCommercialPortail})"/>
          <span slot="footer" class="dialog-footer">
                      <el-button type="primary" @click="selectPortailPayant = false">
                         <span @click="eventAnalytics('modale_diffusion_payante_fermer')">
                            {{ $t("portals.list.close") }}
                         </span>
                      </el-button>
                   </span>
        </el-dialog>
        <el-dialog
            class="ActivationPortailGratuit"
            :visible.sync="activationPortailModal"
            :title="$t('portals.list.activationResultTitle')"
        >
              <span>
                <div
                    v-if="activationPortail != null && activationPortail.reponse.messageHelper">{{ activationPortail.reponse.messageHelper }}</div>
                <div
                    v-if="activationPortail != null && activationPortail.reponse.detail">{{ activationPortail.reponse.detail }}</div>
              </span>
          <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="activationPortailModal = false">
                <span @click="eventAnalytics('modale_diffusion_gratuite_fermer')">
                   {{ $t("portals.list.close") }}
                </span>
             </el-button>
              </span>
        </el-dialog>

        <el-dialog
            v-if="impossibleToActivePortal"
            class="ConfirmDesactivationPortailModal"
            :title="$t('portals.list.impossibleToActiveModalTitle') + impossibleToActivePortal.nom"
            :visible.sync="showImpossibleToActivateModal"
        >
          <div>
            {{ $t("portals.list.impossibleToActiveModalText") }} <br>
            <span v-if="getFromSnake(impossibleToActivePortal, 'email_equipe_commerciale')">
                                 {{ $t("portals.list.mail") }} : {{ getFromSnake(impossibleToActivePortal, 'email_equipe_commerciale') }} <br>
                            </span>
            <span v-if="getFromSnake(impossibleToActivePortal, 'email_equipe_commerciale')">
                                 {{
                $t("portals.list.tel")
              }} : {{ getFromSnake(impossibleToActivePortal, 'email_equipe_commerciale') }}
                            </span>
          </div>
          <span slot="footer" class="dialog-footer">
                            <el-button @click="showImpossibleToActivateModal = false">{{
                                $t("portals.list.confirm")
                              }}</el-button>
                        </span>
        </el-dialog>

        <el-dialog
            class="ConfirmDesactivationPortailModal"
            :title="$t('portals.list.deactivateDiffusionTitle')"
            :visible.sync="confirmDesactivationPortailModal"
        >
          <span>{{ $t("portals.list.deactivateDiffusionText") }}</span>
          <span slot="footer" class="dialog-footer">
                <el-button @click="confirmDesactivationPortailModal = false">{{ $t("portals.list.cancel") }}</el-button>
                <el-button type="primary"
                           @click="desactiverPortail(nomCodePortail)">{{ $t("portals.list.confirm") }}</el-button>
              </span>
        </el-dialog>
        <el-dialog
            class="DesactivationPortailModalResult"
            :title="$t('portals.list.deactivateDiffusionTitle')"
            :visible.sync="desactivationPortailModal"
        >
              <span>
                <div>{{ $t("portals.list.result") }} :</div>
                <div v-if="desactivationPortail != null">
                  <span v-html="desactivationPortail.reponse.success"></span>
                </div>
              </span>
          <span slot="footer" class="dialog-footer">
                <el-button type="primary"
                           @click="desactivationPortailModal = false">{{ $t("portals.list.close") }}</el-button>
              </span>
        </el-dialog>
        <el-dialog
            class="BouquetActiveModal"
            :title="$t('portals.list.activationResultUbiflowPackageTitle')"
            :visible.sync="bouquetActivated"
        >
              <span v-if="activation != null">
                <h3>{{ $t("portals.list.activationResultUbiflowPackageAdded") }} :</h3>
                <div v-for="message in activation.messages.messages" v-bind:key="message">- {{ message }}</div>
              </span>
          <br/>
          <span v-if="activation != null">
                <h3>{{ $t("portals.list.activationResultUbiflowPackageRemoved") }} :</h3>
                <div v-for="erreur in activation.messages.erreurs" v-bind:key="erreur">- {{ erreur }}</div>
              </span>
          <br><br>
          <p>{{ $t("portals.list.activationResultUbiflowPackageMessage") }}</p>
          <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="bouquetActivated = false">{{ $t("portals.list.close") }}</el-button>
              </span>
        </el-dialog>
        <ubi-panel v-if="!isInitialLoading" class="PortalsList" :full-width="browserContext.up('lg')">
          <template slot="header">
            <ubi-list-header
                slot="header"
                :limits="[8, 16, 32]"
                :page.sync="page"
                :limit.sync="limit"
                :total="results.total"
                :sort.sync="sort"
                :sortProperties="sortProperties"
            ></ubi-list-header>
          </template>
          <template slot="selection">
            <ubi-list-selection
                slot="selection"
                v-model="selected"
                :current-page-ids="currentPageIds"
                @select="doSelect"
            />
          </template>
          <template slot="actions">
            <el-button
                icon="export"
                size="mini"
                @click="exporter"
            >{{ $t("portals.list.exportResults") }}
            </el-button>
          </template>
          <ubi-list-footer
              slot="footer"
              :limits="[8, 16, 32]"
              :page.sync="page"
              :limit.sync="limit"
              :total="results.total"
          ></ubi-list-footer>
          <!-- PC : Affichage du tableau en version bureau -->
          <el-table
              ref="tablePortalsList"
              :data="results.list"
              v-if="browserContext.up('lg')"
          >
            <el-table-column fixed width="55" align="center">
              <template v-slot:header>
                <span></span>
              </template>
              <template v-slot="{ row: result }">
                <el-checkbox
                    :value="selected.indexOf(result.id) !== -1"
                    @input="toggleRowSelection(result.id, $event)"
                />
              </template>
            </el-table-column>

            <el-table-column fixed :label="$t('portals.list.columnActivate')" min-width="80">
              <template v-slot="{ row: result }">
                <em class="el-icon-success text-success mr-2" style="font-size:1.9em;"
                    v-if="result && result.diffusion && result.diffusion.active"/>
              </template>
            </el-table-column>
            <el-table-column :label="$t('portals.list.columnLogo')" min-width="120">
              <template v-slot="{ row: result }">
                <img
                    alt=""
                    width="70"
                    :src="result.logo"
                    :srcset="result.logo"
                />
              </template>
            </el-table-column>
            <el-table-column :label="$t('portals.list.columnPortal')" min-width="250">
              <template v-slot="{ row: result }">
                                <span v-if="result.prive === false">
                                    <el-link
                                        target="_blank" rel="noopener"
                                        :href="result.lienSiteUbiflow"
                                    > {{ result.nom }}
                                    </el-link>
                                </span>
                <span v-else>
                                    {{ result.nom }}
                                </span>
              </template>
            </el-table-column>
            <el-table-column :label="$t('portals.list.diffusedAds')" min-width="155" v-if="isMainAccount || isSubAdmin || !quotaPersonnel">
              <template v-slot="{ row: result }">
                <div v-if="result && !result.diffusion">
                  {{ result.diffusion.nbAnnoncesEnvoyees }}
                </div>
                <div v-else-if="result && result.diffusion.nbAnnoncesMax > 0">
                  {{ result.diffusion.nbAnnoncesEnvoyees }}
                </div>
                <div v-else></div>
              </template>
            </el-table-column>
            <el-table-column :label="$t('portals.list.statutDIff')" min-width="80" v-if="isMainAccount || isSubAdmin || !quotaPersonnel">
              <template v-slot="{ row: result }">
                <div v-if="quotaPerUser">
                  <div v-if="result && result.diffusion.nbAnnoncesQuota != 0 && userQuotaPerPortal[result.diffusion.id]">
                    {{ $t("portals.list.limitedTo") }} {{ userQuotaPerPortal[result.diffusion.id].reponse }}
                  </div>
                  <div v-else-if="result && result.diffusion.nbAnnoncesQuota == 0">
                    <div>{{ $t('portals.list.unlimited') }}</div>
                  </div>
                  <div v-else>-</div>
                </div>
                <div v-else>
                  <div v-if="result && result.diffusion.nbAnnoncesQuota != 0">
                    <div>{{ $t("portals.list.limitedTo") }} {{ result.diffusion.nbAnnoncesQuota }}
                    </div>
                  </div>
                  <div v-else-if="result && result.diffusion.nbAnnoncesQuota == 0">
                    <div>{{ $t('portals.list.unlimited') }}</div>
                  </div>
                  <div v-else>-</div>
                </div>
              </template>
            </el-table-column>
            <el-table-column :label="$t('portals.list.numberOfSelectedPrograms')" min-width="235" v-if="sitimmoUser.metier === 'PROMOTEUR'">
              <template v-slot="{row: result}">
                <div style="text-align: center" v-if="result && result.diffusion">{{result.diffusion.nbAnnoncesSelectionneesProgrammes}}</div>
              </template>
            </el-table-column>
            <el-table-column :label="$t('portals.list.selectedAds')" min-width="100" v-if="quotaPersonnel && (!isMainAccount && !isSubAdmin)">
              <template v-slot="{ row: result }">
                <div v-if="result && result.diffusion && usersPortailsQuotas[result.diffusion.id] && usersPortailsQuotas[result.diffusion.id].userPosts">
                  {{ usersPortailsQuotas[result.diffusion.id].userPosts }}
                  <el-tooltip placement="top-start">
                    <div slot="content">{{ $t('portals.broadcast.tooltipSelectedAdsPortals') }}</div>
                    <em class="el-icon-question"></em>
                  </el-tooltip>
                </div>
                <div v-else-if="result && result.diffusion && result.diffusion.nbAnnoncesMax > 0">
                  {{ annonceSelectionneeForPortail[result.diffusion.id] }}
                  <el-tooltip placement="top-start">
                    <div slot="content">{{ $t('portals.broadcast.tooltipSelectedAdsPortals') }}</div>
                    <em class="el-icon-question"></em>
                  </el-tooltip>
                </div>
                <div v-else></div>
              </template>
            </el-table-column>
            <el-table-column :label="$t('portals.list.quotaPerso')" min-width="120" v-if="quotaPersonnel">
              <template v-slot="{ row: result }">
                <div v-if="result && result.diffusion.nbAnnoncesQuota != 0">
                  <div v-if="usersPortailsQuotas[result.diffusion.id]">{{ $t("portals.list.limitedTo") }} {{ usersPortailsQuotas[result.diffusion.id].userQuota }}</div>
                  <div v-else>{{ $t("portals.list.limitedTo") }} 0</div>
                </div>
                <div v-else-if="result && result.diffusion.nbAnnoncesQuota == 0">
                  <div>{{ $t('portals.list.unlimited') }}</div>
                </div>
                <div v-else>-</div>
              </template>
            </el-table-column>
            <el-table-column fixed="right" :label="$t('portals.list.columnSelectAds')" min-width="110" align="center">
              <template v-slot="{ row: result }">
                <router-link v-if="result && result.diffusion.active === true" :to="{ name: 'broadcast', params: { portal: result.diffusion.id }}">
                  <em @click="eventAnalytics('selection_annonces')" class="el-icon-edit"></em>
                </router-link>
                <div v-else>-</div>
              </template>
            </el-table-column>
            <el-table-column fixed="right" :label="$t('portals.list.columnActions')"  min-width="120">
              <template v-slot="{ row: result }">
                <el-dropdown class="inline">
                  <el-button size="mini" icon="more" type="success" @click.prevent.native="" v-if="result && result.diffusion.active === true"></el-button>
                  <el-button size="mini" icon="more" v-else></el-button>
                  <el-dropdown-menu slot="dropdown">
                    <router-link v-if="result" v-on:click.native="eventAnalytics('rapport_diffusion')" :to="{ name: 'report', params: { portal: getFromSnake(result, 'nom_de_code') } }">
                      <el-dropdown-item>{{ $t("portals.list.actionReport") }}</el-dropdown-item>
                    </router-link>
                    <el-dropdown-item v-if="result && result.diffusion.active === true && getFromSnake(result, 'modification_par_annonceur_autorisee') === true && !isSubUser">
                      <span @click="modifierQuotaModal(result)">
                        {{ $t("portals.list.editQuota") }}
                      </span>
                    </el-dropdown-item>
                    <el-dropdown-item v-if="result && result.diffusion.active === true &&  getFromSnake(result, 'modification_par_annonceur_autorisee') === true && !isSubUser">
                      <span @click="modifierIdentifiantsModal(result)">
                        {{ $t("portals.list.editIdentifiants") }}
                      </span>
                    </el-dropdown-item>
                    <el-dropdown-item v-if="sitimmoUser.immowebUrlConnexion && ((getFromSnake(result, 'nom_de_code') == 'IMMOWEB') || (getFromSnake(result, 'nom_de_code') == 'IMMOWEB_API') )">
                      <a v-bind:href="sitimmoUser.immowebUrlConnexion" target="_blank">{{ $t("portals.list.immowebUrlConnexion") }}</a>
                    </el-dropdown-item>
                    <el-dropdown-item v-if="sitimmoUser.selogerUrlConnexion && (result.groupe == 'GROUPE_SELOGER_AVIV')">
                      <a v-bind:href="sitimmoUser.selogerUrlConnexion" target="_blank">{{ $t("portals.list.selogerUrlConnexion") }}</a>
                    </el-dropdown-item>
                    <el-dropdown-item divided v-if="result && result.diffusion.active === true && !user.roles.includes('ROLE_SUB_USER')">
                      <span class="text-danger" @click="{ confirmDesactivationPortailModal = true, nomCodePortail = getFromSnake(result, 'nom_de_code') }">
                        <ubi-icon name="trash"/>{{ $t("portals.list.actionSuspend") }}</span>
                    </el-dropdown-item>
                    <el-dropdown-item divided v-else-if="!user.roles.includes('ROLE_SUB_USER')">
                      <span @click="activerPortailGratuit(result)" class="text-success">{{ $t("portals.list.actionActivate") }}</span>
                    </el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </template>
            </el-table-column>
          </el-table>
          <!-- MOBILE : Affichage du tableau en mode responsive -->
          <ubi-card-container :data="results.list" v-else>
            <template v-slot="{ row: result }">
              <ubi-card v-model="selected" :label="String(result.id)">
                <template slot="header">
                  <div style="text-align: center;">
                    <img
                        alt=""
                        width="50%"
                        :src="result.logo"
                        :srcset="result.logo"
                    />
                  </div>
                </template>
                <el-row type="flex" justify="space-between">
                  <el-col :span="null">
                    <h3>{{result.name}}</h3>
                  </el-col>
                  <el-col :span="null">{{result.categorie}}</el-col>
                </el-row>
                <el-row type="flex" justify="space-between">
                  <el-col :span="null" v-if="result">
                    <small class="text-muted">{{ $t('portals.list.columnAds') }} :</small>
                    <div v-if="quotaPersonnel && (isMainAccount || isSubAdmin) && result && result.diffusion.nbAnnoncesMax > 0" >
                      {{result.diffusion.nbAnnoncesSelectionnees}}
                    </div>
                    <div v-else-if="quotaPersonnel && !isMainAccount && !isSubAdmin && result && result.diffusion.nbAnnoncesMax > 0" >
                      {{ annonceSelectionneeForPortail[result.diffusion.id] }}
                    </div>
                    <div v-else-if="!quotaPersonnel && result && !result.diffusion">
                      {{result.diffusion.nbAnnoncesSelectionnees}}
                    </div>
                    <div v-else-if="result && result.diffusion.nbAnnoncesMax > 0">
                      {{result.diffusion.nbAnnoncesSelectionnees}}
                    </div>
                    <div v-else></div>
                  </el-col>
                </el-row>
                <div class="pt-2">
                  <small class="text-muted">{{ $t('portals.list.columnLastDiffusion') }} :</small>
                  <div
                      v-if="result.dateDernierEnvoi != null && result"
                  >{{formatDate(result.diffusion.dateDernierEnvoi)}} ?
                    {{formatHeure(result.diffusion.dateDernierEnvoi)}}
                  </div>
                  <div v-else>-</div>
                </div>
                <div class="pt-3">
                  <el-button
                      :to="{ name: 'broadcast', params: { portal: result.diffusion.id } }"
                      size="mini"
                      type="warning"
                      class="inline"
                      v-if="result && result.diffusion.active == true"
                  >{{ $t('portals.list.buttonAds') }}
                  </el-button>
                  <el-button
                      size="mini"
                      type="success"
                      plain
                      class="inline"
                      @click="activerPortailGratuit(result)"
                      v-else-if="(result && result.diffusion.active == false) || result.modeleEconomique == 'gratuit'"
                  >{{ $t('portals.list.buttonActivate') }}
                  </el-button>
                  <el-button
                      size="mini"
                      type="success"
                      plain
                      class="inline"
                      @click="{ selectPortailPayant = true, nomPortail= result.nom, nomCodePortail = getFromSnake(result, 'nom_de_code'), emailCommercialPortail = result.email_equipe_commerciale }"
                      v-else
                  >{{ $t('portals.list.buttonActivate') }}
                  </el-button>
                  <el-dropdown class="inline">
                    <el-button size="mini" icon="more"></el-button>
                    <el-dropdown-menu slot="dropdown">
                      <router-link
                          v-if="result"
                          v-on:click.native="eventAnalytics('rapport_diffusion')"
                          :to="{ name: 'report', params: { portal: getFromSnake(result, 'nom_de_code') } }"
                      >
                        <el-dropdown-item>{{ $t("portals.list.actionReport") }}</el-dropdown-item>
                      </router-link>
                      <el-dropdown-item divided
                                        v-if="result && result.diffusion.active == true">
                          <span
                              class="text-danger"
                              @click="{ confirmDesactivationPortailModal = true, nomCodePortail =  getFromSnake(result, 'nom_de_code') }"
                          >
                            <ubi-icon name="trash"/>
                            {{ $t("portals.list.actionSuspend") }}
                          </span>
                      </el-dropdown-item>
                      <el-dropdown-item divided v-else>
                                     <span @click="activerPortailGratuit(result)"
                                           class="text-success">{{ $t("portals.list.actionActivate") }}</span>
                      </el-dropdown-item>
                      <el-dropdown-item><span
                          @click="modifierQuotaModal(result)">Modifier le quota</span>
                      </el-dropdown-item>
                    </el-dropdown-menu>
                  </el-dropdown>
                </div>
              </ubi-card>
            </template>
          </ubi-card-container>
        </ubi-panel>
      </el-form>
      <ubi-panel v-if="!hasDiffusions && !hasDiffusion && allPortals.count === 0">
        <h1>{{ $t('portals.list.noDiffusionTitle') }}</h1>
        <div style="margin-left: 5%; margin-right: 5%;">
          <h3 class="text-center">
            <strong>{{ $t('portals.list.noDiffusionText1') }}</strong>
          </h3>
          <br/><br/>
          <h3>{{ $t('portals.list.noDiffusionText2') }}</h3>
          <p class="text-justify" v-html="$t('portals.list.noDiffusionText3')"/>
          <br/>
          <h3>{{ $t('portals.list.noDiffusionText4') }}</h3>
          <p class="text-justify" v-html="$t('portals.list.noDiffusionText5')"/>
          <br/>
          <h3>{{ $t('portals.list.noDiffusionText6') }}</h3>
          <p class="text-justify" v-html="$t('portals.list.noDiffusionText7')"/>
          <br/>
          <h3>{{ $t('portals.list.noDiffusionText8') }}</h3>
          <p class="text-justify" v-html="$t('portals.list.noDiffusionText9')"/>
          <br/>
          <h3>{{ $t('portals.list.noDiffusionText10') }}</h3>
          <p class="text-justify">
            {{ $t('portals.list.noDiffusionText11') }}
            <a href="https://www.ubiflow.mx/" target="_blank" rel="noopener">
              Contact Manager
            </a>
            <span v-html="$t('portals.list.noDiffusionText12')"/>
            <br><br>
            {{ $t('portals.list.noDiffusionText13') }}
          </p>
        </div>
        <br/>
        <br/>
        <div class="text-center">
          <el-row>
            <el-button @click="send">{{ $t("dashboard.beContacted") }}</el-button>
          </el-row>
          <br/>
          <el-row>
            <el-button type="primary" @click="eventAnalytics('decouvrir_produit')"><a :href="discoverProductLink"
                                                                                      target="_blank" rel="noopener"
                                                                                      id="lienBouton2">{{
                $t("dashboard.decouvrir")
              }}</a>
            </el-button>
          </el-row>
        </div>
      </ubi-panel>
    </div>
  </ubi-page-container>
</template>
<style lang="scss">
@import "@/theme/_bootstrap.scss";

.tralalaPouet {
  background-color: #1e4a56;
}

.PortalsList {
  &-body {
    &--initialLoad {
      min-height: calc(100vh - var(--layout-header-height) - 12rem);
      overflow: hidden;

      .el-loading-spinner {
        top: 50% !important;
        margin-top: -40px;
      }
    }

    &:not(.PortalsList-body--initialLoad) .el-loading-spinner {
      top: 10% !important;
    }
  }

  &-selection {
    @extend .mb-5;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }

  @include media-breakpoint-down(md) {
    &-selection {
      flex-direction: column;
      align-items: flex-start;
    }
    &-export {
      align-self: flex-end;
    }
  }
}

.BouquetActiveModal {
  &-dialog .el-dialog {
    width: 90%;
    max-width: 670px;
  }

  &-container {
    > *:not(:first-child) {
      border-left: 1px solid $gray-200;
    }
  }

  &-actions {
    text-align: right;
  }
}

</style>
<script>
import { mapGetters, mapMutations, mapState } from 'vuex'
import moment from 'moment'
import {
  activerDiffusionAnnonceur,
  desactiverDiffusionAnnonceur,
  exportCsvAllPortails,
  modificationQuotaAnnonces,
  getAllPortals, getUsersPortailsQuotas, modificationIdentifiants, diffusionsAnnonces, getUserPortailsQuotas

} from '@/services/portals'
import { Dialog } from 'element-ui'
import { sendEmail } from '@/services/email'
import UbiPanel from '@/components/Panel.vue'
import ApiSearchForm from '@/components/search/ApiSearchForm.vue'
import { getFromSnake } from '@/helpers/functions/getFromSnake'
import UbiPageContainer from '@/components/PageContainer.vue'
import { getCategoryLabel } from '@/helpers/functions/categoryFilterById'

export default {
  name: 'PortalsList',
  inject: ['browserContext'],
  components: {
    UbiPageContainer,
    UbiPanel,
    ElDialog: Dialog,
    ApiSearchForm
  },
  data () {
    return {
      loading: false,
      dialogVisible: false,
      quotaPerUser: false,
      quotaPersonnel: false,
      bouquetActivated: false,
      diffDateSemaineDerniereRemonteeTeteDeListe: 0,
      currentPortalQuota: null,
      currentPortal: null,
      activation: null,
      activationPortail: null,
      activationPortailModal: false,
      confirmDesactivationPortailModal: false,
      desactivationPortailModal: false,
      desactivationPortail: null,
      remontee: null,
      messageRemontee: null,
      allPortals: [],
      annonceSelectionneeForPortail: [],
      modificationQuotaModal: false,
      modificationIdentifiantsModal: false,
      identifiantsEditableAnnonceur: false,
      identifiantsValeurs: {},
      limits: [10, 10 * 2, 10 * 5],
      selected: [],
      allPortalsSelected: [],
      nbAnnoncesSelectionneesForUser: [],
      nbAnnoncesActiveForUser: 0,
      selectPortailPayant: false,
      selectPortailPayantResultat: false,
      nomCodePortail: null,
      emailCommercialPortail: 'test@test.com',
      nomPortail: null,
      choixModalQuota: 'turnoff',
      limitQuota: 0,
      portailIsPayant: null,
      info: '',
      file: null,
      userQuotaPerPortal: [],
      showAllPortalsView: false,
      sortProperties: {
        nom: this.$t('general.sort.name'),
        date: this.$t('general.sort.lastDiffusion'),
        annonces: this.$t('general.sort.ads')
      },
      filters: [
        { value: 'all', label: this.$t('general.filters.allPortals') },
        { value: 'active', label: this.$t('general.filters.activePortals') },
        { value: 'inactive', label: this.$t('general.filters.inactivePortals') }
      ],
      selection: null,
      showImpossibleToActivateModal: false,
      impossibleToActivePortal: null,
      usersPortailsQuotas: {},
      excludedCategories: 'réseaux sociaux,biens vendus',
      pendingMergePage: null,
      selectAllMode: false
    }
  },
  computed: {
    ...mapGetters(['isMainAccount', 'isSubAdmin', 'isSubUser', 'getPickerOptionsShortcuts', 'hasDiffusions']),
    ...mapGetters('productLine', ['hasDiffusion']),
    ...mapState('portals', ['filter', 'results']),
    sitimmoUser () {
      return this.$store.getters.getSitimmoUser
    },
    possedeContactManager () {
      return getFromSnake(this.sitimmoUser, 'possede_contact_manager')
    },
    universe () {
      return this.sitimmoUser.univers
    },
    nbStocks () {
      return this.sitimmoUser.stocks.length
    },
    stocks () {
      return this.sitimmoUser.stocks
    },
    pickerOptions () {
      return {
        shortcuts: this.getPickerOptionsShortcuts
      }
    },
    user () {
      return this.$store.getters.getUser
    },
    page: {
      get () {
        return this.filter.page
      },
      async set (value) {
        window.scrollTo(0, 0)
        this.setPage(value)
        await this.fetchList()
        this.toggleSelection()
        // return this.setPage(value);
      }
    },
    limit: {
      get () {
        return this.filter.limit
      },
      async set (value) {
        this.setLimit(value)
        await this.fetchList()
        return this.setLimit(value)
      }
    },
    sort: {
      get () {
        return this.filter.sort
      },
      async set (value) {
        this.setSort(value)
        await this.fetchList()
        return this.setSort(value)
      }
    },
    discoverProductLink () {
      if (this.universe === 'IMMO') {
        return 'https://www.ubiflow.net/solutions-diffusion-immo.php'
      } else {
        return 'https://www.ubiflow.net/solutions-diffusion-auto.php'
      }
    },
    // ===== COMPUTED POUR ApiSearchForm =====
    templateCode () {
      // Le template sera sélectionné automatiquement selon le businessDomain
      return null // Le backend choisira entre portals_list_immo et portals_list_vo
    },
    businessDomain () {
      return this.universe === 'IMMO' ? 'immo' : 'vo'
    },
    route () {
      return 'portals'
    },
    currentPageIds () {
      return (this.results.list || []).map(({ id }) => id)
    },
    isInitialLoading () {
      return this.loading && this.results.total === -1
    }
  },
  beforeMount () {
    this.loading = true
    if (!this.hasDiffusions && !this.hasDiffusion) {
      this.resetFilter()
      this.fetchList()
    }
    this.$store.dispatch('donnees/loadCategories')
  },
  mounted () {
    this.loading = true
    window.scrollTo(0, 0)
    if (this.possedeContactManager === false) {
      delete this.sortProperties.contact
    }
  },
  watch: {
    'filter.page' (newPage, oldPage) {
      if (this.selectAllMode && oldPage != null && newPage !== oldPage) {
        this.pendingMergePage = newPage
      }
    },
    'results.list' (list) {
      if (
        this.selectAllMode &&
        this.pendingMergePage != null &&
        this.filter.page === this.pendingMergePage &&
        list &&
        list.length
      ) {
        this.selected = [...new Set([...(this.selected || []), ...this.currentPageIds])]
        this.pendingMergePage = null
        this.toggleSelection()
      }
    }
  },
  methods: {
    getFromSnake,
    eventAnalytics (category) {
      this.$ga.event('liste_diffusions', 'clic', category, this.sitimmoUser.id)
    },
    // ===== MÉTHODES POUR ApiSearchForm =====
    async handleSearchFromApi (filters) {
      console.log('🔍 [NOUVEAU] Recherche depuis ApiSearchForm:', filters)

      // Mapper les filtres d'ApiSearchForm vers le format attendu par le store Vuex

      // Add for retrieve category by id
      const category = getCategoryLabel(this.$store, filters.category)

      const mappedFilters = {
        search: filters.search || '',
        category: category || null,
        gratuit: filters.gratuit || null,
        quota: filters.quota || null,
        stock: filters.stock || null,
        after: filters.after || null,
        before: filters.before || null,
        active: filters.preset === 'active' ? true : (filters.preset === 'inactive' ? false : null),
        preset: filters.preset || 'active',
        page: 1 // Reset à la page 1 lors d'une nouvelle recherche
      }

      console.log('📦 [NOUVEAU] Filtres mappés pour le store:', mappedFilters)

      // Mettre à jour le store Vuex
      this.setFilter(mappedFilters)

      // Lancer la recherche
      await this.fetchList()
    },

    async handleResetFromApi () {
      console.log('🔄 [NOUVEAU] Réinitialisation depuis ApiSearchForm')

      // Réinitialiser les filtres
      this.resetFilter()

      // Relancer la recherche
      await this.fetchList()
    },

    async exporter () {
      let i = 0
      let strSelectedIds = null
      this.selected.forEach(function (idSelected) {
        if (i === 0) {
          strSelectedIds = idSelected
        } else {
          strSelectedIds = strSelectedIds + ',' + idSelected
        }
        i++
      })
      this.loading = true
      const filename = this.$t('portals.list.filenameExportDiffusions')
      const res = await exportCsvAllPortails(this.filter, strSelectedIds, false, filename)
      this.$message(res)
      this.loading = false
    },
    convertDate: function (date) {
      return moment(date).format('DD/MM/YYYY')
    },
    ...mapMutations('portals', [
      'setPage',
      'setLimit',
      'setSort',
      'setSearch',
      'setCategory',
      'setGratuit',
      'setFilter',
      'addFilter',
      'setResults',
      'setQuota',
      'setAfter',
      'setBefore',
      'resetFilter',
      'setStock'
    ]),
    async fetchList () {
      this.loading = true
      this.filter.excludedCategories = this.excludedCategories
      this.allPortals = await getAllPortals(this.filter)
      if (this.allPortals.type === 'error') {
        // this.$message({message: this.$t("error.found"), type: 'error'});
        this.loading = false
        return false
      }
      // QUOTA :
      if ((this.user.identifierValue != null) && (this.user.identifierCode != null)) {
        await this.chargementDonneesQuotas()
      }
      this.loading = false
      this.setResults(this.allPortals)
    },
    resetFiltersAndFetch () {
      this.resetFilter()
      this.showAllPortalsView = true
      this.fetchList()
    },
    async chargementDonneesQuotas () {
      this.quotaPersonnel = true
      // Quotas users
      const resultUsersPortailsQuotas = await getUserPortailsQuotas()
      for (let i = 0; i < resultUsersPortailsQuotas.length; i++) {
        const usersPortail = resultUsersPortailsQuotas[i]
        for (let j = 0; j < usersPortail.usersQuotas.length; j++) {
          const userQuotas = usersPortail.usersQuotas[j]
          // Gestion des quotas sans utilisateur
          if (userQuotas && userQuotas.userId) {
            this.usersPortailsQuotas[usersPortail.diffusionId] = userQuotas
          }
        }
      }
      // Annonces sélectionnées
      for (let i = 0; i < this.allPortals.results.length; i++) {
        const portail = this.allPortals.results[i]
        if (this.usersPortailsQuotas[portail.diffusion.id]) {
          this.annonceSelectionneeForPortail[portail.diffusion.id] = this.usersPortailsQuotas[portail.diffusion.id].userPosts
        } else if (portail.diffusion.nbAnnoncesQuota === 0) {
          const filters = {}
          filters.diffuseurCode = getFromSnake(portail, 'nom_de_code')
          const diffusions = diffusionsAnnonces(filters)
          this.annonceSelectionneeForPortail[portail.diffusion.id] = diffusions.length
        } else {
          this.annonceSelectionneeForPortail[portail.diffusion.id] = portail.diffusion.nbAnnoncesSelectionnees
        }
      }
    },
    async modifierQuotaModal (result) {
      this.modificationQuotaModal = true
      this.currentPortalQuota = result
      if (result) {
        this.limitQuota = result.diffusion.nbAnnoncesQuota
        if (this.limitQuota === 0) {
          this.choixModalQuota = 'unlimited'
        } else {
          this.choixModalQuota = 'limit'
        }
      }
    },
    async modifierQuota () {
      if (this.choixModalQuota == 'turnoff') {
        this.desactivationPortail = await desactiverDiffusionAnnonceur(getFromSnake(this.currentPortalQuota, 'nom_de_code'))
        this.modificationQuotaModal = false
        this.desactivationPortailModal = true
      }
      if (this.choixModalQuota == 'unlimited') {
        this.desactivationPortail = await modificationQuotaAnnonces(getFromSnake(this.currentPortalQuota, 'nom_de_code'), 0)
      }
      if (this.choixModalQuota == 'limit') {
        this.desactivationPortail = await modificationQuotaAnnonces(getFromSnake(this.currentPortalQuota, 'nom_de_code'), this.limitQuota)
      }
      this.modificationQuotaModal = false
      this.fetchList()
    },
    async modifierIdentifiantsModal (result) {
      this.modificationIdentifiantsModal = true
      this.currentPortal = result
      this.identifiantsEditableAnnonceur = false
      for (const numero in this.currentPortal.diffusion.identifiants) {
        const identifiant = this.currentPortal.diffusion.identifiants[numero]
        if (getFromSnake(identifiant, 'editable_annonceur') === true) {
          this.identifiantsEditableAnnonceur = true
        }
      }
    },
    async modifierIdentifiants () {
      const identifiants = []
      for (const numero in this.currentPortal.diffusion.identifiants) {
        const identifiant = this.currentPortal.diffusion.identifiants[numero]
        if (identifiant.editable === true) {
          identifiants[identifiant.numero] = identifiant.valeur
        }
        if (identifiant.caracteristique_annonceur && !identifiant.valeur) {
          this.identifiantsErreurs.push(identifiant.numero)
        }
      }
      modificationIdentifiants(this.currentPortal.diffusion.id, identifiants)
      this.modificationIdentifiantsModal = false
    },
    formatDate: function (date) {
      return date ? date.substring(0, 10) : null
    },
    async activerPortailGratuit (portal) {
      if (getFromSnake(portal, 'modification_par_annonceur_autorisee') === false) {
        this.showImpossibleToActivateModal = true
        this.impossibleToActivePortal = portal
        return false
      }

      this.activationPortail = await activerDiffusionAnnonceur(getFromSnake(portal, 'nom_de_code'))
      if (this.activationPortail.type == 'error') {
        // this.$message({message: this.$t("error.found"), type: 'error'});
        this.loading = false
        return false
      }
      this.activationPortailModal = true
    },
    async desactiverPortail (nomCodePortail) {
      this.confirmDesactivationPortailModal = false
      this.desactivationPortail = await desactiverDiffusionAnnonceur(nomCodePortail)
      if (this.desactivationPortail.type == 'error') {
        // this.$message({message: this.$t("error.found"), type: 'error'});
        this.loading = false
        return false
      }
      this.desactivationPortailModal = true
    },
    formatHeure: function (date) {
      return date ? date.substring(10, 16) : null
    },
    doFilter (type) {
      this.filter.preset = type
      this.filter.page = 1
      switch (type) {
        case 'all':
          this.filter.active = null
          this.filter.diffuseurCodeNames = null
          this.setFilter(this.filter)
          break
        case 'active':
          this.filter.active = true
          this.filter.diffuseurCodeNames = null
          this.setFilter(this.filter)
          break
        case 'inactive':
          this.filter.active = false
          this.filter.diffuseurCodeNames = null
          this.setFilter(this.filter)
          break
      }
      this.fetchList()
    },
    doSelect (type) {
      switch (type) {
        case '*':
          this.selectAllMode = true
          const tmpSelection = this.currentPageIds
          this.selected = [...new Set([...(this.selected || []), ...tmpSelection])]
          this.toggleSelection()
          // this.$refs.tablePortalsList.toggleAllSelection();
          break
        case null:
        default:
          this.selected = []
          this.selectAllMode = false
          this.pendingMergePage = null
          // this.selection = "";
          if (this.$refs.tablePortalsList) {
            this.$refs.tablePortalsList.clearSelection()
          }
      }
    },
    toggleRowSelection (id, checked) {
      const index = (this.selected || []).indexOf(id)
      if (checked && index === -1) {
        this.selected = [...(this.selected || []), id]
      } else if (!checked && index > -1) {
        this.selected = this.selected.filter((selectedId) => selectedId !== id)
      }
    },
    toggleSelection () {
      if (!this.$refs.tablePortalsList) {
        return
      }
      this.results.list.forEach(row => {
        if (this.selected.includes(row.id)) {
          this.$refs.tablePortalsList.toggleRowSelection(row, true)
        }
      })
    },
    selectAllChanged (selection) {
      // unselect all case
      if (!selection.length) {
        const self = this
        this.results.list.forEach(function (item) {
          const index = self.selected.indexOf(item.id)
          if (index > -1) {
            this.selected.splice(index, 1)
          }
        }, self)
        // this.$refs.tablePortalsList.clearSelection();
      } else { // select all case
        this.doSelect('*')
      }
    },
    selectedChanged (selection, row) {
      let add = false
      selection.forEach(function (item) {
        if (item.id === row.id) {
          add = true
        }
      })
      const index = this.selected.indexOf(row.id)
      if (add) {
        if (index === -1) {
          this.selected.push(row.id)
        }
      } else {
        if (index > -1) {
          this.selected.splice(index, 1)
        }
      }
    },
    upperCase (string) {
      if (!string) return ''
      return string.charAt(0).toUpperCase() + string.substr(1)
    },
    async send () {
      this.eventAnalytics('etre_contacte')
      this.loading = true
      this.sendTo = processEnvConfig.VUE_APP_ADRESSE_MAIL_CONTACT_MARKETING
      const mailData = {
        to: this.sendTo,
        subject: 'Client ' + this.sitimmoUser.login + ' : Diffusion - Demande de contact',
        content: 'Le client ' + this.sitimmoUser.login + '(' + this.sitimmoUser.nom + ') a fait une demande de contact sur le nouvel espace client pour la solution "Diffusion". Vous pouvez le recontacter via ' + this.sitimmoUser.email + ' ou au numéro ' + this.sitimmoUser.telephone
      }
      const response = await sendEmail(mailData)
      if (response.type === 'error') {
        // this.$message({message: this.$t("error.found"), type: 'error'});
        this.loading = false
        return false
      }
      this.loading = false
      window.alert('Vous souhaitez des informations sur notre produit Diffusion. Notre équipe va prendre contact avec vous dans les meilleurs délais')
      // self.$message(response);
    },
    showActiveDiffusions () {
      this.resetFilter()
      this.filter.active = true
      this.showAllPortalsView = false
      this.fetchList()
    }
  }
}
</script>

<style lang="scss">
@import "@/theme/_bootstrap.scss";

.PortalsList {
  /* Personnalisation du Panel de recherche : garder barre verte, supprimer ombre/bordures */
  ::v-deep .el-card.Panel.is-always-shadow {
    box-shadow: none !important;
    -webkit-box-shadow: none !important;
    border-left: none !important;
    border-right: none !important;
    border-top: none !important;
    border: none !important;
    border-bottom: none !important;
  }

  /* Réduire le padding du Panel de 34px à 5px */
  ::v-deep .el-card.Panel.is-always-shadow .el-card__body {
    padding: 5px !important;
  }
}

#lienBouton2 {
  color: white;
  text-decoration: none;
}
</style>
